// extracted by mini-css-extract-plugin
module.exports = {"block":"_1844","title":"_10823","rate":"_11638","average":"_9982","status":"_795","item":"_8129","red":"_8800","divider":"_6310"};